import axios from "axios";

import Config from "../../../config";

const v2_actionMetaVincularPagina = (canalId, data) => {
    let url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/meta/canal/${canalId}/vincular-pagina`;
    return axios({
        method: "post",
        url: url,
        data: data
    });
};

export default v2_actionMetaVincularPagina;
